import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/inbox-documents/:inboxDocumentId/isAutomationEnabled`;

export type GetAutomationEnabledResponse = {
  isEnabled: boolean;
};

export const getAutomationEnabledQueryKey = (inboxDocumentId: number) => [
  INBOX_API_KEY,
  'is-automation-enabled',
  inboxDocumentId,
];

export const GetAutomationEnabled = (
  inboxDocumentId: number
): Promise<GetAutomationEnabledResponse> => {
  return axios.get(generateRoutePath(url, { inboxDocumentId }));
};
type QueryFnType = typeof GetAutomationEnabled;

type UseGetAutomationEnabledOptions = {
  inboxDocumentId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAutomationEnabled = ({
  inboxDocumentId,
  config,
}: UseGetAutomationEnabledOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: getAutomationEnabledQueryKey(inboxDocumentId),
    queryFn: () => GetAutomationEnabled(inboxDocumentId),
    staleTime: Infinity,
    ...config,
  });
};
